module.exports = __webpack_public_path__ + "img/mainhomephn3.453ea1a3.png";